import { render, staticRenderFns } from "./AssignOrdersPickupRider.vue?vue&type=template&id=c7652408&"
import script from "./AssignOrdersPickupRider.vue?vue&type=script&lang=js&"
export * from "./AssignOrdersPickupRider.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrdersPickupRider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports